var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-17);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.43,
    y1: 14,
    x2: 23.57,
    y2: 14,
    gradientTransform: "translate(0 26) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0067bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000c55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3.02,
    y1: 11.14,
    x2: 19.03,
    y2: 11.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 8.09,
    y1: 13.99,
    x2: 11.71,
    y2: 13.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 12.29,
    y1: 14,
    x2: 16.57,
    y2: 14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 10.59,
    y1: 8.47,
    x2: 13.1,
    y2: 8.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 10.63,
    y1: 7.12,
    x2: 13.06,
    y2: 7.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 14.72,
    y1: 8.55,
    x2: 15.57,
    y2: 8.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 16.92,
    y1: 10.85,
    x2: 17.97,
    y2: 10.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 17.73,
    y1: 14,
    x2: 18.85,
    y2: 14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 16.92,
    y1: 17.15,
    x2: 17.97,
    y2: 17.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 14.72,
    y1: 19.45,
    x2: 15.57,
    y2: 19.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 11.71,
    y1: 20.29,
    x2: 12.29,
    y2: 20.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 8.43,
    y1: 19.45,
    x2: 9.28,
    y2: 19.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 4.97,
    y1: 16.86,
    x2: 20.98,
    y2: 16.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 6.03,
    y1: 17.15,
    x2: 7.08,
    y2: 17.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 5.15,
    x2: 6.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 6.03,
    y1: 10.85,
    x2: 7.08,
    y2: 10.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 8.43,
    y1: 8.55,
    x2: 9.28,
    y2: 8.55,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12,23.57c6.38,0,11.57-5.19,11.57-11.57S18.38,.43,12,.43,.43,5.62,.43,12c0,6.38,5.19,11.57,11.57,11.57h0Zm11-11.57c0,6.06-4.93,11-11,11S1,18.06,1,12,5.94,1,12,1s11,4.93,11,11h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.45,19.08c0,.15,.14,.27,.29,.27,0,0,0,0,.02,0,.16,0,.28-.14,.27-.3l-.08-1.48c0-.16-.14-.28-.3-.27l-1.48,.08c-.16,0-.28,.14-.27,.3s.15,.28,.3,.27l.77-.04c-1.05,1.06-2.35,1.82-3.8,2.21-.73,.19-1.46,.29-2.17,.29-3.71,0-7.11-2.48-8.12-6.23-.45-1.68-.37-3.43,.22-5.05,.05-.15-.02-.32-.17-.37-.15-.05-.32,.02-.37,.17-.64,1.74-.72,3.61-.24,5.4,1.07,4.01,4.71,6.66,8.68,6.66,.77,0,1.55-.1,2.32-.31,1.56-.42,2.97-1.24,4.09-2.38l.04,.79h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M11.71,16.57V7.44c-2.02,.15-3.62,1.84-3.62,3.9,0,1.13,.49,2.2,1.34,2.94,.69,.6,1.08,1.39,1.15,2.28h1.13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.32,12c0,1.18-.89,2.16-2.03,2.3v2.27h.21l.07-.81c.01-.13,.1-.23,.23-.26,.4-.09,.78-.25,1.13-.47,.11-.07,.24-.06,.34,.02l.62,.53,.7-.7-.53-.62c-.08-.1-.09-.23-.02-.34,.22-.35,.38-.73,.47-1.13,.03-.12,.13-.21,.26-.22l.81-.07v-.99l-.81-.07c-.13-.01-.23-.1-.26-.22-.09-.4-.25-.78-.47-1.13-.07-.11-.06-.24,.02-.34l.53-.62-.7-.7-.62,.53c-.1,.08-.23,.09-.34,.02-.35-.22-.73-.38-1.13-.47-.12-.03-.21-.13-.23-.26l-.07-.81h-.21v2.27c1.14,.14,2.03,1.12,2.03,2.3h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M12.62,17.14h-2.03v.78h2.51v-.19l-.48-.59h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M13.06,18.5h-2.43c.13,.45,.54,.78,1.02,.78h.38c.49,0,.9-.33,1.02-.78Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M14.76,17.36l.27,.47c.05,.09,.15,.14,.25,.14,.05,0,.1-.01,.15-.04,.14-.08,.18-.26,.11-.39l-.27-.47c-.08-.14-.26-.18-.39-.11-.14,.08-.18,.26-.11,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M17.07,15.26l.47,.27s.09,.04,.14,.04c.1,0,.2-.05,.25-.14,.08-.14,.03-.31-.1-.39l-.47-.27c-.14-.08-.31-.03-.39,.11-.08,.14-.03,.31,.11,.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M18.02,12.29h.54c.16,0,.29-.13,.29-.29s-.13-.29-.29-.29h-.54c-.16,0-.29,.13-.29,.29,0,.16,.13,.29,.29,.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M17.36,9.24l.47-.27c.14-.08,.18-.26,.1-.39-.08-.14-.26-.18-.39-.11l-.47,.27c-.14,.08-.19,.26-.11,.39,.05,.09,.15,.14,.25,.14,.05,0,.1-.01,.15-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M15.26,6.93l.27-.47c.08-.14,.03-.31-.11-.39-.14-.08-.32-.03-.39,.11l-.27,.47c-.08,.14-.03,.31,.11,.39,.05,.03,.1,.04,.15,.04,.1,0,.2-.05,.25-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.29,5.98v-.54c0-.16-.13-.29-.29-.29s-.29,.13-.29,.29v.54c0,.16,.13,.29,.29,.29s.29-.13,.29-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M9.24,6.64l-.27-.47c-.08-.14-.26-.18-.39-.11-.14,.08-.18,.26-.11,.39l.27,.47c.05,.09,.15,.14,.25,.14,.05,0,.1-.01,.15-.04,.14-.08,.18-.26,.1-.39h0Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M7.1,6.32c0-.16-.15-.28-.3-.27l-.78,.04c1.05-1.06,2.35-1.82,3.8-2.21,2.17-.58,4.43-.28,6.38,.84,1.94,1.12,3.33,2.93,3.91,5.1,.45,1.68,.37,3.43-.22,5.05-.05,.15,.02,.31,.17,.37,.03,.01,.07,.02,.1,.02,.12,0,.23-.07,.27-.19,.64-1.74,.72-3.61,.24-5.4-1.28-4.78-6.21-7.63-11-6.35-1.56,.42-2.97,1.24-4.09,2.38l-.04-.79c0-.16-.14-.28-.3-.27-.16,0-.28,.14-.27,.3l.08,1.48c0,.15,.14,.27,.29,.27h.02l1.48-.08c.16,0,.28-.14,.27-.3h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M6.46,8.47c-.14-.08-.31-.03-.39,.11-.08,.14-.03,.31,.1,.39l.47,.27s.1,.04,.15,.04c.1,0,.2-.05,.25-.14,.08-.14,.03-.31-.11-.39l-.47-.27h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M5.98,11.71h-.54c-.16,0-.29,.13-.29,.29s.13,.29,.29,.29h.54c.16,0,.29-.13,.29-.29s-.13-.29-.29-.29h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M6.64,14.76l-.47,.27c-.14,.08-.18,.26-.1,.39,.05,.09,.15,.14,.25,.14,.05,0,.1-.01,.14-.04l.47-.27c.14-.08,.19-.26,.11-.39s-.26-.18-.39-.11h0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M8.74,17.07l-.27,.47c-.08,.14-.03,.31,.11,.39,.05,.03,.1,.04,.15,.04,.1,0,.2-.05,.25-.14l.27-.47c.08-.14,.03-.31-.1-.39-.14-.08-.31-.03-.39,.11h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.68a092980e90e46282651902a153b703.svg";
export { ForwardRef as ReactComponent };